import { render, staticRenderFns } from "./PrintItems.vue?vue&type=template&id=0474e91b&scoped=true&"
import script from "./PrintItems.vue?vue&type=script&lang=js&"
export * from "./PrintItems.vue?vue&type=script&lang=js&"
import style0 from "./PrintItems.vue?vue&type=style&index=0&id=0474e91b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474e91b",
  null
  
)

export default component.exports